module.exports = __webpack_public_path__ + "img/erweima.71ffd8cb.png";